module.exports = "/static/assets/e389e587fca11d3a2930383e2440078e.png";